import React from 'react'
import paperclip from '../icons/Paper clip.svg'
import '../App.css'


const FileSelectionComponent = ({
    sourceClick,
    integrations,
    multipleFileList,
    removeFile,
    orgId,
    folder='templates',
}) => {
    return (
        <>
            {multipleFileList.length === 0 && (
            <div className="tiles-container">
                {integrations.map((integration, index) => (
                    <div className="tile" key={index}>
                        <button className="tile-content" onClick={sourceClick}>
                            <img src={integration.img} alt={integration.name} />
                            <p style={{ fontWeight: 'bold' }}>
                                {integration.status}
                            </p>
                        </button>
                    </div>
                ))}
            </div>
            )}
            {multipleFileList.length > 0 && (
            <div style={{ marginTop: '2vh' }} className="input-container">
                {multipleFileList.length === 1 && (
                    <p style={{ textAlign: 'left' }}>Selected Document:</p>
                )}
                {multipleFileList.length > 1 && (
                    <p style={{ textAlign: 'left' }}>Selected Documents:</p>
                )}
                <div className="multiple-file-upload-card-container">
                    {multipleFileList.map((file, index) => (
                        <div
                            className="multiple-file-upload-card"
                            key={file.name}
                        >
                            <div className="file-info">
                                <img src={paperclip} alt="Paperclip" />
                                <p className="file-name">
                                    {file.name.replace(
                                        `${orgId}/${folder}/`,
                                        ''
                                    )}
                                </p>
                            </div>
                            <button
                                className="remove-file-btn"
                                onClick={() => removeFile(index)}
                            >
                                Remove
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            )}
        </>
    )
}

export default FileSelectionComponent;